module.exports = __webpack_public_path__ + "media/common/icon-weather-clear-daytime-94de290a.svg";